var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 pt-0 pb-0"},[_c('v-layout',{staticClass:"pb-2 flex-wrap justify-content-between"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }